import { TextField } from "@mui/material";
import { useFormikContext } from "formik";
import { NumericFormat } from "react-number-format";

const InvoiceAmount = () => {
  const { values, touched, handleBlur, errors, setFieldValue } =
    useFormikContext();

  return (
    <NumericFormat
      onValueChange={(v, _) => setFieldValue("invoice_amount", v.floatValue)}
      customInput={TextField}
      fullWidth
      size="small"
      label="Invoice Amount"
      value={values["invoice_amount"]}
      name="invoice_amount"
      onBlur={handleBlur}
      required
      error={touched.invoice_amount && Boolean(errors.invoice_amount)}
      helperText={touched.invoice_amount && errors.invoice_amount}
    />
  );
};

export default InvoiceAmount;
